import {axiosWithToken,axiosWithOutTokenWithAccessToken,axiosWithOutToken} from './network.es6';
export const isLogin = () => new Promise((resolve, reject) => {
    //初期化
    const auth = JSON.parse(sessionStorage.getItem('auth'));
    console.log(auth);
    if (auth !== null) {
        if ('access_token' in auth)  {
            // ログインセッションが切断されています。もう一度ログインしなおしてください。
            loginRenew(auth.access_token)
                .then((result) => {
                    sessionStorage.auth = JSON.stringify(result.auth);
                    sessionStorage.user = JSON.stringify(result.user);
                    sessionStorage.removeItem('cartToken');
                    resolve(result);
                })
                .catch((em) => {
                    reject('ログインセッションが切断されています。もう一度ログインしなおしてくださいa');
                });
        } else {
            reject('ログインセッションが切断されています。もう一度ログインしなおしてください');
        }
    } else {
        reject('ページが見つからないか、ログインセッションが切断されています。もう一度ログインしなおしてください');
    }
});
export const getAuthToken = () => new Promise((resolve, reject) => {
    const postData = {};
    axiosWithToken({ url: '/api/auth/login_exist', method: 'post', data: postData })
        .then((response) => {
            if (response.data.status === 'TRUE') {
                resolve(response.data);
            } else {
                reject([response.data.developerMessage]);
            }
        });
});
export const login = (email,password) => new Promise((resolve, reject) => {
    const post = {
        email: email,
        password: password,
        grant_type: 'access_token'
    };
    axiosWithOutToken({url: '/api/oauth/token', method: 'post', data: post})
        .then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            } else {
                reject('ログイン失敗。')
            }
        })
        .catch((response) => {
            reject([response])
        });
});
export const getUser = () => new Promise((resolve, reject) => {
    const data = {};
    axiosWithOutTokenWithAccessToken({url: '/api/user/account', method: 'get', data: data})
        .then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            } else {
                reject('取得失敗。')
            }
        })
        .catch((response) => {
            reject([response])
        });
});
export const getUserData = () => new Promise((resolve, reject) => {
    const data = {};
    axiosWithOutTokenWithAccessToken({url: '/api/user/userdata', method: 'get', data: data})
        .then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            } else {
                reject('取得失敗。')
            }
        })
        .catch((response) => {
            reject([response])
        });
});
export const getUserAccount = () => new Promise((resolve, reject) => {
    const data = {};
    axiosWithOutTokenWithAccessToken({url: '/api/user/account', method: 'get', data: data})
        .then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            } else {
                reject('取得失敗。')
            }
        })
        .catch((response) => {
            reject([response])
        });
});
export const logout = () => new Promise((resolve, reject) => {
    const auth = JSON.parse(sessionStorage.getItem('auth'),true);
    const post = {
        'access_token': auth.access_token,
    };
    axiosWithToken({url: '/gift/api/auth/logout', method: 'post', data: post})
        .then((response) => {
            if (response.data.status === 'TRUE') {
                sessionStorage.clear();
                resolve();
            } else {
                reject(response.data.userMessage)
            }
        })
        .catch((response) => {
            reject([response])
        });
});
export const forceLogout = () => new Promise((resolve, reject) => {
    axiosWithToken({url: '/gift/api/auth/logout', method: 'post', data: {}})
        .then((response) => {
            if (response.data.status === 'TRUE') {
                sessionStorage.clear();
                resolve();
            } else {
                reject(response.data.userMessage)
            }
        })
        .catch((response) => {
            reject([response])
        });
});

export const loginExec = (email,password) => new Promise((resolve, reject) => {
    const post = {
        email: email,
        password: password,
        grant_type: 'access_token'
    };
    axiosWithToken({url: '/gift/api/auth/login_exec', method: 'post', data: post})
        .then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            } else {
                reject('ログイン失敗。')
            }
        })
        .catch((response) => {
            reject([response])
        });
});
export const loginRenew = (access_token) => new Promise((resolve, reject) => {
    const post = {
        access_token: access_token,
    };
    axiosWithToken({url: '/gift/api/auth/login_renew', method: 'post', data: post})
        .then((response) => {
            if (response.data.status === 'TRUE') {
                resolve(response.data);
            } else {
                reject(response.data.userMessage)
            }
        })
        .catch((response) => {
            reject([response])
        });
});

